import styled from "styled-components";

export const ContainerCoupon = styled.div`
  width: 100%;
`

export const ColInput = styled.div`
  margin: 0 auto;
  width: 100%;
`;

type ButtonProp = {
  color: string;
}

export const Button = styled.button<ButtonProp>`
  padding: 10px 20px;
  background-color: ${props => props.color};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  font-size: 16px;
  margin-top: 10px;
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const CouponApplied = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: green;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: red;
  font-size: 16px;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
  }

  svg {
    margin-left: 5px;
  }
`;
